import type { PageEntry, Entry, Node } from 'contensis-delivery-api';
import dynamic from 'next/dynamic';
import cmsParser from 'Common/util/cmsParser';

import type { Props } from './Listing';

export type PageData = {
    entry: PageEntry;
    ancestors: Node[];
    residences: Entry[];
};

const datamap = (data: PageData): Props => {
    const { entry, ancestors, residences } = data;

    return {
        breadcrumbs: cmsParser.breadcrumbs([
            ...ancestors,
            { entry: { title: entry.title }, id: entry.sys.id }
        ]),
        heroBanner: cmsParser.heroBannerWave(entry.heroBannerWaveDefault),
        whatsIncludedHeading: entry.whatsIncludedHeading,
        whatsIncludedList: {
            items: entry.whatsIncludedList.map((item, index) => ({
                id: item.iconId || index,
                text: item.listItemText,
                icon: dynamic(() =>
                    import('@solent-university/solent-icons').then(icons => icons[item.icon.name])
                )
            })),
            columns: { base: 1 }
        },
        studentAccommodationImage: cmsParser.image(entry.studentAccommodationCodeImage),
        otherOptionsHeading: entry.otherOptionsHeading,
        otherOptionsBtns: entry.iconButtons.map(item => ({
            ...cmsParser.link(item),
            id: item.link.sys.id,
            icon: dynamic(() =>
                import('@solent-university/solent-icons').then(icons => icons[item.icon.name])
            ),
            variant: 'accentSeven'
        })),
        accommodationCards: residences.map(item => ({
            heading: item.title,
            image: {
                default: cmsParser.image(item.listingImage),
                mobile: cmsParser.image(item.listingImageLandscape)
            },
            address: item.heroBannerImageDefault.heroBannerWaveDefault.postHeading,
            distance: `${item.distanceFromCampus} walk`,
            text: item.introText,
            price: item.priceFrom,
            featureList: item.residenceFeatures.map(feature => ({
                icon: dynamic(() =>
                    import('@solent-university/solent-icons').then(
                        icons => icons[feature.icon.name]
                    )
                ),
                description: feature.listItemText
            })),
            link: {
                label: 'Discover more',
                href: item.sys.uri,
                ariaLabel: `Discover more on ${item.title}`
            }
        }))
    };
};

export default datamap;
